import { SharedModule } from 'app/shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditorModule } from '@tinymce/tinymce-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AccountsRoutingModule } from './accounts-routing.module';

import { ACCOUNT_DECLARATIONS } from './accounts.imports';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AccountSettingsComponent } from './account-settings/account-settings.component';
import { PrefsGoalsComponent } from './prefs-goals/prefs-goals.component';
import { PrefsPipelineComponent } from './prefs-pipeline/prefs-pipeline.component';
import { ChangeTimezoneComponent } from './change-timezone/change-timezone.component';
import { UpdatePersonalInfoComponent } from './update-personal-info/update-personal-info.component';
import { BillingInformationComponent } from './billing-information/billing-information.component';
import { SetVariablesComponent } from './set-variables/set-variables.component';
import { BccManageComponent } from './bcc-manage/bcc-manage.component';
import { ViewRepresentativesComponent } from './view-representatives/view-representatives.component';
import {
  ManagerRoleRendererComponent,
} from './view-representatives/manager-role-renderer/manager-role-renderer.component';
import {
  ResetAccountPasswordComponent,
} from './view-representatives/reset-account-password/reset-account-password.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { EditAccountComponent } from './list-accounts/edit-account/edit-account.component';
import {
  ChangeAccountPasswordComponent,
} from './list-accounts/change-account-password/change-account-password.component';
import { SetNotificationEmailComponent } from './list-accounts/set-notification-email/set-notification-email.component';
import { SetContactLimitComponent } from './list-accounts/set-contact-limit/set-contact-limit.component';
import { SetSendLimitComponent } from './list-accounts/set-send-limit/set-send-limit.component';
import { SuspendEmailsComponent } from './list-accounts/suspend-emails/suspend-emails.component';
import { InboxManagementComponent } from './inbox-management/inbox-management.component';
import { VsmAssignComponent } from '../list-accounts/vsm-control/vsm-assign/vsm-assign.component';
import { VsmInfoComponent } from '../list-accounts/vsm-info/vsm-info.component';

@NgModule({
  declarations: [
    ...ACCOUNT_DECLARATIONS,
    ChangePasswordComponent,
    AccountSettingsComponent,
    PrefsGoalsComponent,
    PrefsPipelineComponent,
    ChangeTimezoneComponent,
    UpdatePersonalInfoComponent,
    BillingInformationComponent,
    SetVariablesComponent,
    BccManageComponent,
    ViewRepresentativesComponent,
    ManagerRoleRendererComponent,
    ResetAccountPasswordComponent,
    EditAccountComponent,
    ChangeAccountPasswordComponent,
    SetNotificationEmailComponent,
    SetContactLimitComponent,
    SetSendLimitComponent,
    SuspendEmailsComponent,
    InboxManagementComponent,
    VsmAssignComponent,
    VsmInfoComponent,
    // ...UI_DECLARATIONS
    // ...AUTHENTICATED_DECLARATIONS
  ],
  imports: [
    // ...UI_IMPORTS,
    SharedModule,
    CommonModule,
    AccountsRoutingModule,
    EditorModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
  ],
  providers: [
    // ...UI_PROVIDERS
  ],
})
export class AccountsModule {
}
